<template>
	<div class="bottom_left">
		<div class="bottom_left_header">
			<div class="left_header_left">
				<img class="header_left_icon" src="@/assets/img/big_data/jqsq.png">
				<div class="header-title">状态监控</div>
			</div>
			<div class="left_header_right">NUMBER OF PATENTS GRANTED</div>
			<div class="bordline"></div>
		</div>
		<div>
			<div class="left_btn_status">
				<div class="left_btn_status_one"></div>
				<div class="left_btn_status_two">
					<div class="left_btn_status_title">近期代缴年费</div>
					<div class="left_btn_status_content">
						<span class="fee-value" @click="feeJump('recent',leftBottomData.recent_num)" title="查询详情">{{ leftBottomData.recent_num }}</span>
						<span class="fee-unit">件</span>
					</div>
				</div>
				<div class="left_btn_status_three">
					<div class="left_btn_status_title">待缴金额</div>
					<div class="left_btn_status_content">
						<span class="fee-value" @click="feeJump('recent',leftBottomData.recent_fee)" title="查询详情">{{ leftBottomData.recent_fee }}</span>
						<span class="fee-unit">元</span>
					</div>
				</div>
			</div>
			<div class="left_btn_status">
				<div class="left_btn_status_one"></div>
				<div class="left_btn_status_two">
					<div class="left_btn_status_title">滞纳期专利</div>
					<div class="left_btn_status_content">
						<span class="fee-value" @click="feeJump('late',leftBottomData.late_num)" title="查询详情">{{ leftBottomData.late_num }}</span>
						<span class="fee-unit">件</span>
					</div>
				</div>
				<div class="left_btn_status_three">
					<div class="left_btn_status_title">滞纳金</div>
					<div class="left_btn_status_content">
						<span class="fee-value" @click="feeJump('late',leftBottomData.late_fee)" title="查询详情">{{ leftBottomData.late_fee }}</span>
						<span style="color: #9BC1FF;font-size: 20px;font-weight: 400;padding-left: 4px;">元</span>
					</div>
				</div>
			</div>
			<div class="left_btn_status">
				<div class="left_btn_status_one"></div>
				<div class="left_btn_status_two">
					<div class="left_btn_status_title">失效待恢复</div>
					<div class="left_btn_status_content">
						<span class="fee-value" @click="feeJump('restore',leftBottomData.restore_num)" title="查询详情">{{ leftBottomData.restore_num }}</span>
						<span class="fee-unit">件</span>
					</div>
				</div>
				<div class="left_btn_status_three">
					<div class="left_btn_status_title">恢复金额</div>
					<div class="left_btn_status_content">
						<span class="fee-value" @click="feeJump('restore',leftBottomData.restore_fee)" title="查询详情">{{ leftBottomData.restore_fee }}</span>
						<span class="fee-unit">元</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'LeftBottom',
	props: {
		leftBottomData: {
			type: Object,
			default: () => { }
		}
	},
	methods: {
		// 跳转监控管理列表
		feeJump(tag,val){
			if(val <= 0){
			this.$message({
				type: 'info',
				message: '数据为空~'
				})
			return false
		}
		localStorage.setItem('consoleStatus',tag)
		window.open('#/patent/monitor','_blank')
		}
	},
	mounted() {},
}
</script>
<style lang="stylus" scoped>
.bottom_left{
    margin-top:40px;
    width: 411px;
    height: 364px;
    border-radius: 10px;
    border: 1px solid rgba(221, 252, 255, 0.2);
    background-color:rgba(221, 252, 255, 0.1);
    position: relative
    .bottom_left_tips{
        display:flex;
        justify-content:space-between;
        padding: 0 60px;
        position:absolute;
        width:100%;
        bottom:22px;
        box-sizing:border-box;
        color: #FEFEFE;
        font-weight: 400;
        font-size:12.5px;
        .tips_item{
            display:flex;
            align-items:center
        }
        .tips_item_box{
            width: 14px;
            height: 14px;
            background: #8ADE83;
            border-radius: 4px;
            margin-right:5px
        }
    }
   .bottom_left_header{
        display:flex;
        height:56px;
        align-items:center;
        justify-content:space-between;
        margin-left:27px;
        margin-right:29px;
		position: relative;
		.bordline{
            width:100%;
            height:1px;
            background:linear-gradient(to right,rgba(0,0,0,0)0%,#9BC1FF 50%,rgba(0,0,0,0)100%);
            position:absolute;
            bottom:0
        }
   }
    .left_header_right{
        color: #B7D2FF;
        font-size: 12px;
        font-weight: 500;
        opacity: 0.2;
    }
    .left_header_left{
       
        display:flex;
        height:56px;
        align-items:center
        .header-title{
            font-size: 21px;
            font-family: 'Alimama ShuHeiTi';
            font-weight: bold;
            color: #9BC1FF;
        }
        .header_left_icon{
            width:23px;
            height:21px;
            margin-right:15px
        }
    } 
	.left_btn_status{
		height: 80px;
		width: 365px;
		border-radius: 10px;
		margin-left: 27px;
		margin-top: 13px;
		display: flex;
		.left_btn_status_one{
			width: 22px;
			background: #9BC1FF;
			border-radius: 10px 0px 0px 10px;
		}
		.left_btn_status_two{
			width: 174px;
			background: rgba(86, 111, 150, 0.8);
		}
		.left_btn_status_three{
			width: 161px;
			background: rgba(86, 111, 150, 0.5);
			border-radius: 0px 10px 10px 0px;
		}
		.left_btn_status_title{
			font-size: 17px;
			color: #9BC1FF;
			font-family: FZHei-B01S;
			font-weight: 400;
			margin-left: 10px;
			margin-top: 14px;
		}
		.left_btn_status_content{
			margin-left: 10px;
			margin-top: 12px;
		}

	}
	.fee-value {
		color: #FFFFFF;
		font-size: bold;
		font-size: 24px;
		cursor pointer;
	}
	.fee-unit {
		color: #9BC1FF;
		font-size: 20px;
		font-weight: 400;
		padding-left: 4px;
	}
}
</style>


// WEBPACK FOOTER //
// src/views/console/components/LeftBottom.vue